module.exports = __webpack_public_path__ + "img/blobby-on-a-scooter.329ea914.jpg";